import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import IconPopover from '@core/dashboard/components/IconPopover';
import { ToolsIcon } from '@icons';

import { useToolsState } from './hooks';
import Tools from './Tools';

import {
  ModalContainer,
  Header,
} from '@core/dashboard/components/PopoverModal';
import { isMobileOnly } from 'react-device-detect';

const ToolActions = () => {
  const { t: translate } = useTranslation();

  const { resetState } = useToolsState();

  useEffect(() => resetState, []);

  return (
    <IconPopover
      icon={<ToolsIcon />}
      label={translate('actions.tools')}
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      analyticsName='tools'
    >
      {({ onClose }) => (
        <ModalContainer
          header={
            <Header text={translate('actions.tools')} onClose={onClose} />
          }
        >
          <Tools onClose={onClose} />
        </ModalContainer>
      )}
    </IconPopover>
  );
};

export default ToolActions;
